import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

const updateScheduleStatus = async ({
  scheduleId,
  enable,
}: {
  scheduleId: number;
  enable: number;
}): Promise<any> => {
  const response = await instance.put(`/nexa/schedule/status/${scheduleId}`, { enable });
  return response.data;
};

export const useUpdateScheduleStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateScheduleStatus,
    onSuccess: (data) => {
      message.success(data?.message || 'Schedule status updated');
      queryClient.invalidateQueries({ queryKey: ['nexa-schedule-list'] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message || 'Failed to update schedule status');
    },
  });
};
